import React, { useState, useCallback, useEffect,  forwardRef, useImperativeHandle } from "react";
import { connect } from "react-redux";
import "../../../../css/salesorder.css";
import SalesOrderSearchResult from "./../salesOrdersTab/SalesOrderSearchResult";
import OrderDetailResult from "./../salesOrdersTab/OrderDetailResult";
import AROpenItemsResult from "./../salesOrdersTab/AROpenItemsResult";
import ItemMasterResult from "./../salesOrdersTab/ItemMasterResult";
import ItemOrdersTabResult from './ItemOrdersTabResult'
import ItemMasterSearchResultsMain from "./ItemMasterSearchResultsMain";
import OpenRequisitionsTabResult from "./OpenRequisitionsTabResult";
import OpenPosTabResult from "./OpenPosTabResult";
import OpenPosReceiptTabResult from "./OpenPosReceiptTabResult";
import AllTransactionTabResult from "./AllTransactionTabResult";
import CustomerContactResult from "../salesOrdersTab/CustomerContactResult";
import CustomerResult from "../salesOrdersTab/CustomerResult";
import ItemLocationTabResult from "./ItemLocationTabResult";
import LocationTabResult from "./LocationTabResult";
import CustomerTabResult from "./CustomerTabResult";
import LotTab from "../../../../../im/codes/itemDataEntry/tabs/LotTab";
import {
    GetLookupData, GetSalesOrderGridData, GetOrderDetailGridData, GetArOpenItemGridData
    , GetItemMasterGridData, GetItemMasterMainGridData, GetLookupStaticData
} from "../../../../services/SalesOrderService";
const ItemOrderTab = 1;
const openRequisitionsTab = 2;
const openPOsTab = 3;
const openPOsReceiptTab = 4;
const allTransactionsTab = 5;
const itemMasterTab = 6;
const customerTab = 7;
const locationMAsterTab = 8;
const itemLocationTab = 9;
const lotTab = 10;
const getSalesOrderUrl = "om/SaleOrder/GetItemMasterMain";
const getOrderDetailSearchUrl = "om/SaleOrder/GetItemOrder";
const getArOpenItemshUrl = "om/SaleOrder/GetArOpenItems";
const getOpenRequisitionsUrl = "om/SaleOrder/GetOpenRequisitions";
const GetItemMasterDetailsUrl = "om/SaleOrder/GetItemMasterDetails";
const GetPosUrl = "om/SaleOrder/GetPos";
const GetPosReceiptUrl = "om/SaleOrder/GetPosReceipt";
const GetTransactionsUrl = "om/SaleOrder/GetTransactions";
const GetLocationsUrl = "om/SaleOrder/GetLocations";
const GetItemLocationUrl = "om/SaleOrder/GetItemLocations";
const getProfileUrl = "om/SaleOrder/GetProfiles";
const getCustomerUrl = "om/SaleOrder/GetCustomers";
const getCustomerListUrl = "om/SaleOrder/GetCustomerList";
const ItemMasterTabs =forwardRef((props, ref) => {
    
    const [activeTab, setActiveTab] = useState(ItemOrderTab);
    const [itemOrderDataSource, setitemOrderDataSource] = useState(null);
    const [allTransactonDataSource, setAllTransactonDataSource] = useState(null);
    const [openReqDataSource, setopenReqDataSource] = useState(null);
    const [ItemMasterDataSource, setItemMasterDataSource] = useState(null);
    const [PosDataSource, setPosDataSource] = useState(null);
    const [PoReceiptDataSource, setPoReceiptDataSource] = useState(null);
    //const [selectedRow, setselectedRow] = useState(props.selectedRow);
    const [customerDataSource, setCustomerDataSource] = useState(null);
    const [ItemLocationDataSource, setItemLocationDataSource] = useState(null);
    const [LocationDataSource, setLocationDataSource] = useState(null);
    const [selectedRow, setSelectedRow] = useState(null);

    var accessToken = props.accessToken;
    
    useImperativeHandle(ref, () => ({
        updateData(data) {
            setSelectedRow(data);
        }
      }));
      

    const handleTabClick = (tabIndex) => {
        setActiveTab(tabIndex);
    };
    useEffect(() => {
        LoadTabsData();
    }, [selectedRow, activeTab]);

    const LoadTabsData = () => {
        if (selectedRow) {
            if (selectedRow.rowid && activeTab === ItemOrderTab) {
                var resultData = GetOrderDetailGridData(accessToken, getOrderDetailSearchUrl, selectedRow.rowid);
                setitemOrderDataSource(resultData);
            } else if (selectedRow.rowid && activeTab === openRequisitionsTab) {
                var resultData = GetOrderDetailGridData(accessToken, getOpenRequisitionsUrl, selectedRow.rowid);
                setopenReqDataSource(resultData);
            }
            else if (selectedRow.rowid && activeTab === openPOsTab) {
                var resultData = GetOrderDetailGridData(accessToken, GetPosUrl, selectedRow.rowid);
                setPosDataSource(resultData);
            }
            else if (selectedRow.rowid && activeTab === openPOsReceiptTab) {
                var resultData = GetOrderDetailGridData(accessToken, GetPosReceiptUrl, selectedRow.rowid);
                setPoReceiptDataSource(resultData);
            }
            else if (selectedRow.rowid && activeTab === allTransactionsTab) {
                var resultData = GetOrderDetailGridData(accessToken, GetTransactionsUrl, selectedRow.rowid);
                setAllTransactonDataSource(resultData);
            }
            else if (selectedRow.rowid && activeTab === itemLocationTab) {
                var resultData = GetOrderDetailGridData(accessToken, GetItemLocationUrl, selectedRow.rowid);
                setItemLocationDataSource(resultData);
            }
        }
        if (activeTab === customerTab) {
            var resultData = GetItemMasterGridData(accessToken, getCustomerListUrl);
            setCustomerDataSource(resultData);
        }
        else if (activeTab === itemMasterTab) {
            var resultData = GetItemMasterGridData(accessToken, getSalesOrderUrl);
            setItemMasterDataSource(resultData);
        }
        else if (activeTab === locationMAsterTab) {
            var resultData = GetItemMasterGridData(accessToken, GetLocationsUrl);
            setLocationDataSource(resultData);
        }
    }
    return (
        <>
            <div className="tab-bar">
                <div
                    className={`tab ${activeTab === ItemOrderTab ? 'active' : ''}`}
                    onClick={() => handleTabClick(ItemOrderTab)}
                >
                    Item Orders
                </div>
                <div
                    className={`tab ${activeTab === openRequisitionsTab ? 'active' : ''}`}
                    onClick={() => handleTabClick(openRequisitionsTab)}
                >
                    Open Requisitions
                </div>
                <div
                    className={`tab ${activeTab === openPOsTab ? 'active' : ''}`}
                    onClick={() => handleTabClick(openPOsTab)}
                >
                    Open POs
                </div>
                <div
                    className={`tab ${activeTab === openPOsReceiptTab ? 'active' : ''}`}
                    onClick={() => handleTabClick(openPOsReceiptTab)}
                >
                    Open PO Receipts
                </div>
                <div
                    className={`tab ${activeTab === allTransactionsTab ? 'active' : ''}`}
                    onClick={() => handleTabClick(allTransactionsTab)}
                >
                    All Transactions
                </div>
                <div
                    className={`tab ${activeTab === itemMasterTab ? 'active' : ''}`}
                    onClick={() => handleTabClick(itemMasterTab)}
                >
                    Item Master
                </div>
                <div
                    className={`tab ${activeTab === customerTab ? 'active' : ''}`}
                    onClick={() => handleTabClick(customerTab)}
                >
                    Customers
                </div>
                <div
                    className={`tab ${activeTab === locationMAsterTab ? 'active' : ''}`}
                    onClick={() => handleTabClick(locationMAsterTab)}
                >
                    Location Master
                </div>
                <div
                    className={`tab ${activeTab === itemLocationTab ? 'active' : ''}`}
                    onClick={() => handleTabClick(itemLocationTab)}
                >
                    Item/Locations
                </div>
                <div
                    className={`tab ${activeTab === lotTab ? 'active' : ''}`}
                    onClick={() => handleTabClick(lotTab)}
                >
                    Lots
                </div>
            </div>
            {activeTab === ItemOrderTab && (
                <ItemOrdersTabResult data={itemOrderDataSource} />
            )}
            {activeTab === openRequisitionsTab && (
                <OpenRequisitionsTabResult data={openReqDataSource} />
            )}
            {activeTab === itemMasterTab && (
                <ItemMasterResult data={ItemMasterDataSource} />
            )}
            {activeTab === openPOsTab && (
                <OpenPosTabResult data={PosDataSource} />
            )}
            {activeTab === openPOsReceiptTab && (
                <OpenPosReceiptTabResult data={PoReceiptDataSource} />
            )}
            {activeTab === allTransactionsTab && (
                <AllTransactionTabResult data={allTransactonDataSource} />
            )}
            {activeTab === customerTab && (
                <CustomerTabResult data={customerDataSource} />
            )}
            {activeTab === locationMAsterTab && (
                <LocationTabResult data={LocationDataSource} />
            )}
            {activeTab === itemLocationTab && (
                <ItemLocationTabResult data={ItemLocationDataSource} />
            )}
            {activeTab === lotTab && (
                <LotTab key={selectedRow?.rowid ?? "no-selection"} rowId={selectedRow?.rowid} />
            )}
        </>
    );
});
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default ItemMasterTabs;